import React from "react";
import highquality from "../../assets/services/highquality.png";
import right from "../../assets/right.png";
import { useTranslation } from "react-i18next";

const EverythingGuaranteed = () => {

  const { t, i18n } = useTranslation();
  const { language } = i18n;

  return (
    <div className="bg-[#FCFBFA] my-14 py-16 max-lg:my-5 max-lg:py-5 px-20 max-lg:px-5 relative">
      <img src={highquality} className="w-[90px] max-lg:w-[70px] absolute right-0 -top-14" />
      <div className="text-center">
        <h2 className="text-[#14294F] text-3xl max-lg:text-xl font-semibold">
          {t("everythingGuaranteed.title")}
        </h2>
        <p className="text-[#737E91] text-lg mt-5  max-lg:w-full text-center mx-auto">
          {t("everythingGuaranteed.description")}
        </p>
      </div>
      <div className="grid grid-cols-3 max-lg:grid-cols-1 gap-10 text-[#14294F] text-xl font-medium text-center mt-14 max-lg:mt-10">
        <div>
          <img src={right} className="w-[50px] mx-auto" />
          <p className="mt-4 w-1/2 mx-auto">{t("everythingGuaranteed.seamlessPurchases")}</p>
        </div>
        <div>
          <img src={right} className="w-[50px] mx-auto" />
          <p className="mt-4">{t("everythingGuaranteed.easyBooking")}</p>
        </div>
        <div>
          <img src={right} className="w-[50px] mx-auto" />
          <p className="mt-4 w-1/2 mx-auto">{t("everythingGuaranteed.requestPreviews")}</p>
        </div>
      </div>
    </div>
  );
};

export default EverythingGuaranteed;